module.exports = __webpack_public_path__ + "img/c53a475.jpg";